import EncountersHistory from '../Encounter/EncountersHistory'
import { Modal } from '../shared/NarusMaterial'

export default function EncounterHistoryModal (props) {
  return (
    <Modal
      {...props}
      title='Encounter History'
    >
      <EncountersHistory
        modal
        {...props}
      />
    </Modal>
  )
}
